module.exports = __webpack_public_path__ + "img/Ellipse2516.bf49bf1d.svg";